var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLaundry(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_444_7941",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 25,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.667969,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_444_7941)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.98606 11.3267L2.47656 6.98268L8.38431 3.58643H9.34181C9.61498 4.37493 10.0413 5.05768 10.6208 5.63468C11.2003 6.21151 11.883 6.49993 12.6688 6.49993C13.4713 6.49993 14.1623 6.21151 14.7418 5.63468C15.3213 5.05768 15.7393 4.37493 15.9958 3.58643H16.9533L22.8361 7.00768L20.3516 11.3267L18.1688 10.1287V16.4807L17.1016 17.3902C17.0951 17.403 17.0871 17.4111 17.0776 17.4144C17.0679 17.4176 17.0534 17.4192 17.0341 17.4192V8.19418L19.9361 9.79218L21.2861 7.42292L16.8266 4.81718C16.3996 5.68134 15.8146 6.36693 15.0718 6.87393C14.3288 7.38109 13.5278 7.63468 12.6688 7.63468C11.8201 7.63468 11.0217 7.38109 10.2736 6.87393C9.52556 6.36693 8.93806 5.68134 8.51106 4.81718L4.02656 7.42292L5.41681 9.79218L8.30356 8.19418V13.7229C8.11756 13.7499 7.9259 13.7865 7.72856 13.8327C7.53106 13.8788 7.34448 13.941 7.16881 14.0192V10.1287L4.98606 11.3267ZM5.36306 18.7077L4.62856 17.8364L6.46881 16.2769C6.83298 15.9731 7.23873 15.7426 7.68606 15.5854C8.13356 15.4284 8.58615 15.3499 9.04381 15.3499C9.50148 15.3499 9.9499 15.4284 10.3891 15.5854C10.8281 15.7426 11.2296 15.9731 11.5938 16.2769L14.4938 18.7519C14.7463 18.9711 15.0296 19.1297 15.3438 19.2277C15.658 19.3258 15.983 19.3749 16.3188 19.3749C16.638 19.3749 16.9588 19.3243 17.2813 19.2229C17.6038 19.1218 17.8881 18.9648 18.1343 18.7519L19.9746 17.1519L20.7091 18.0479L18.8688 19.6077C18.5046 19.9115 18.1031 20.1378 17.6641 20.2864C17.2249 20.4351 16.7765 20.5094 16.3188 20.5094C15.8611 20.5094 15.4086 20.4351 14.9611 20.2864C14.5137 20.1378 14.108 19.9115 13.7438 19.6077L10.8593 17.1327C10.6131 16.9133 10.3288 16.7547 10.0063 16.6567C9.68381 16.5585 9.36298 16.5094 9.04381 16.5094C8.70798 16.5094 8.38298 16.5585 8.06881 16.6567C7.75465 16.7547 7.47131 16.9133 7.21881 17.1327L5.36306 18.7077Z",
    fill: "#A3A3A3"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLaundry);
export default __webpack_public_path__ + "static/media/laundry.8ab5cecb432c03a974d4fc31d2b443b9.svg";
export { ForwardRef as ReactComponent };